import PropTypes from 'prop-types';
import withAdRegistration from 'src/common/decorators/ads/withAdRegistration';
import css from './videoAd.module.scss';

export function VideoAdSlot() {
  return <div id="web-media-player-ad-container" className={css.videoAdSlot} />;
}

function LegacyVideoAdSlot({ height, id }) {
  return <div id={id} className={css.videoAdSlot} style={{ height }} />;
}

LegacyVideoAdSlot.propTypes = {
  slotNames: PropTypes.array,
  id: PropTypes.string,
  height: PropTypes.number,
};

export default withAdRegistration({
  autoPlay: false,
  refreshOnPageChange: false,
})(LegacyVideoAdSlot);
